import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, style, ...props }, ref) => {
  return (
    <input
      type={type}
      style={style}
      className={cn(
        "flex h-9 w-full rounded-md border border-white/10 bg-black/30 px-3 py-1 text-base text-white shadow-sm transition-all duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-white placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#D4AF37] focus-visible:border-[#D4AF37] focus-visible:bg-black/40 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        // Autofill styles to prevent white background
        "[&:-webkit-autofill]:bg-black/30 [&:-webkit-autofill]:[-webkit-text-fill-color:#fff] [&:-webkit-autofill]:shadow-[inset_0_0_0px_1000px_#0B0F1A] [&:-webkit-autofill]:[-webkit-box-shadow:inset_0_0_0px_1000px_#0B0F1A] [&:-webkit-autofill:hover]:shadow-[inset_0_0_0px_1000px_#0B0F1A] [&:-webkit-autofill:focus]:shadow-[inset_0_0_0px_1000px_#0B0F1A] [&:-webkit-autofill:active]:shadow-[inset_0_0_0px_1000px_#0B0F1A]",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
